import { useContext, useRef } from "react";
import { CustomModal } from "../../layouts/customModal";
import { Button } from "flowbite-react";
import ExcelEditor from "../../components/file-uploader/excelEditor";
import { StatusContext } from "../../context/statusProvider";

export const ExcelModal = ({ fileData, subCategory }) => {
  const modalRef = useRef(null);
  const openRef = useRef(null);
  const { handleApi } = useContext(StatusContext);

  const handleClose = () => {
    modalRef.current();
  };

  return (
    <CustomModal
      closeOnOutsideClick={false}
      btnText={"Update Excel"}
      modalRef={modalRef}
      openRef={openRef}
      customBtn={
        <div id="modalBtnSuccess" className="mt-4">
          <Button
            onClick={() => {
              openRef.current();
            }}
          >
            {"Edit file"}
          </Button>
        </div>
      }
    >
      <ExcelEditor
        filePath={fileData.file}
        fileName={fileData.file_name}
        fileData={fileData}
        subCategory={subCategory}
        handleClose={handleClose}
        handleApi={handleApi}
      />
    </CustomModal>
  );
};
